import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { BaseMiscDomainService } from 'src/app/_common/domain/base-misc-domain.service';
import { PolicyMiscApiService } from '../api/policy-misc-api.service';
import { MediaTypes } from 'src/app/_common/services/files.service';


@Injectable({
    providedIn: 'root'
})
export class PolicyMiscDomainService extends BaseMiscDomainService
{
    constructor(
        private policyMiscApiService: PolicyMiscApiService
    )
    {
        super();
    }

    export (qs: string, format: MediaTypes): Observable<HttpEvent<Blob>>
    {
        return this.policyMiscApiService.export(qs, format);
    }
}
